/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
const TEAM_VALUE_PREFIX = 'team:';

type TeamValue = `team:${string}`;

export const isTeamValue = (value: string): value is TeamValue =>
  value.startsWith(TEAM_VALUE_PREFIX);

export const toTeamValue = (teamId: string) => `${TEAM_VALUE_PREFIX}${teamId}`;

export const getTeamId = (teamValue: TeamValue) => teamValue.slice(TEAM_VALUE_PREFIX.length);
